import { render, staticRenderFns } from "./DataCleanup.vue?vue&type=template&id=43afe985"
import script from "./DataCleanup.vue?vue&type=script&lang=js"
export * from "./DataCleanup.vue?vue&type=script&lang=js"
import style0 from "./DataCleanup.vue?vue&type=style&index=0&id=43afe985&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports